import React, { useEffect, useMemo, useState } from 'react'
import { Table } from '../../components/tables/Table';
import { FiAlertTriangle, FiCheckCircle, FiEdit, FiEye, FiPrinter, FiSearch } from 'react-icons/fi';
import { M_Document } from './documents/M_Document';
import { useDispatch, useSelector } from 'react-redux';
import { loadDetailRequest, loadDetailRequestPDF, loadRequests } from '../../app/store/requests/thunk';
import { requests_status, status_requests_colors } from '../../app/Constants';
import { Loading } from '../../components/Loading';
import { useForm } from 'react-hook-form';
import { getFirstDayCurrentMonth, getLastDayCurrentMonth } from '../../utils/Custom';

export const ListRequests = ({ parentData, navigateTo }) => {

    const dispatch = useDispatch();
    const { register, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({
        mode: 'all', defaultValues: {
            estado: 0
        }
    });

    //Variables
    // let firstDay = getFirstDayCurrentMonth(); let lastDay = getLastDayCurrentMonth();

    const firstDay = useMemo(() => getFirstDayCurrentMonth(), []);
    const lastDay = useMemo(() => getLastDayCurrentMonth(), []);

    useEffect(() => {
        let statusOrder = 0; // default (todos)

        if (parentData?.STATUSID) {
            statusOrder = parentData.STATUSID;

            setValue('estado', statusOrder);
        }

        dispatch(loadRequests(firstDay, lastDay, statusOrder))
    }, [parentData, firstDay, lastDay, dispatch])

    const { isLoading, catRequests, detailRequestPDF, detailItemsPDF, msg } = useSelector(state => state.requests);
    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = (order) => {
        dispatch(loadDetailRequestPDF(order));
    };

    useEffect(() => {
        const hasRequest = detailRequestPDF && Object.keys(detailRequestPDF).length > 0;
        const hasItems = Array.isArray(detailItemsPDF) && detailItemsPDF.length > 0;

        if (hasRequest && hasItems) {
            setShowModal(true);
        }
    }, [detailRequestPDF, detailItemsPDF]);


    const handleCloseModal = () => {
        setShowModal(false);

    };

    const searchOrdenes = (data) => {
        dispatch(loadRequests(data.fechaInicial, data.fechaFinal, data.estado))
    }

    const [selectedItem, setSelectedItem] = useState(null);
    const purchaseOrders = [...catRequests];

    let columns = [
        {
            header: 'FOLIO',
            dataIndex: 'NUMBER',
            classHeader: 'text-start',
            classRow: 'text-start',
            // renderer: (value, row) => (
            //     <>
            //         <button type="button" className="btn btn-link" onClick={() => { setSelectedItem(value); navigateTo('edit', { id: row.NUMBER }); }} >{value}</button>
            //     </>
            // ),
            renderer: (value, row) => {

                const status = Number(row.STATUSID); // Asegura número

                const buttons = [];

                // ➤ Status 1 y 2 → Mostrar EDITAR
                if (status === 1 || status === 2) {
                    buttons.push(
                        <button
                            key="edit"
                            type="button"
                            className="btn btn-link border-0"
                            title="Editar Orden"
                            onClick={() => navigateTo('edit', { id: row.NUMBER })}
                        >
                            {value}
                        </button>
                    );
                }

                // ➤ Status 3,4 → Mostrar IMPRIMIR y RECIBIR
                if (status === 3 || status === 4 || status === 5) {


                    buttons.push(
                        <button
                            key="receive"
                            type="button"
                            className="btn btn-link border-0"
                            title="Recibir Orden"
                            onClick={() => navigateTo('receive', { id: row.NUMBER })}
                        >
                            {value}
                        </button>
                    );
                }

                // ➤ Status 6 Ver reporte de recibido
                if (status === 6) {
                    buttons.push(
                        <button
                            key="view"
                            type="button"
                            className="btn btn-link border-0"
                            title="Ver Orden"
                            // onClick={() => handleOpenModal('pdf', row.NUMBER)}
                            onClick={() => navigateTo('history', { id: row.NUMBER })}
                        >
                            {value}
                        </button>
                    );
                }

                // // ➤ Status 7 → No mostrar nada
                if (status === 7) {
                    buttons.push(
                        <button
                            key="edit"
                            type="button"
                            className="btn btn-link border-0"
                            title="Ver Historial de Orden"
                            onClick={() => navigateTo('history', { id: row.NUMBER })}
                        >
                            {value}
                        </button>
                    );
                }

                return (
                    <div className="btn-group border-0" role="group">
                        {buttons}
                    </div>
                );
            }
        },
        {
            header: 'REGISTRO',
            dataIndex: 'USERNAME_REGISTER',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'FECHA',
            dataIndex: 'DATEREGISTER',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'HORA',
            dataIndex: 'HOURREGISTER',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'APROBADO',
            dataIndex: 'USERNAME_REVIEW',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'FECHA APROB.',
            dataIndex: 'DATEREVIEWER',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'HR. APROB.',
            dataIndex: 'HOURREVIEWER',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'REC. PARCIAL',
            dataIndex: 'USERNAME_PARCIAL',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'F. REC. PARCIAL',
            dataIndex: 'DATEPARCIAL',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'HR. REC. PARCIAL',
            dataIndex: 'HOURPARCIAL',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'USUARIO CANCELO',
            dataIndex: 'USERNAME_CANCELED',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'FECHA CANCELADO',
            dataIndex: 'DATECANCELED',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'HR. CANCELADO',
            dataIndex: 'HOURCANCELED',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'USUARIO ACOMPLETO',
            dataIndex: 'USERNAME_COMPLETED',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'FECHA COMPLETO',
            dataIndex: 'DATECOMPLETED',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'HR. COMPLETO',
            dataIndex: 'HOURCOMPLETED',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const hasValue = value && value.trim() !== '';
                return (
                    <span className={hasValue ? '' : 'text-muted'}>
                        {hasValue ? value : 'NA'}
                    </span>
                );
            }
        },
        {
            header: 'ESTADO',
            dataIndex: 'STATUSID',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => {
                const code = Number(value);
                return (
                    <span className={`badge text-white ${status_requests_colors[code]}`}>
                        {row.STATUSDESC}
                    </span>
                );
            }

        },
        {
            header: 'ACCIONES',
            dataIndex: 'status',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => {

                const status = Number(row.STATUSID); // Asegura número
                const buttons = [];

                // ➤ Status 1 y 2 → Mostrar EDITAR
                if (status === 1 || status === 2) {
                    buttons.push(
                        <button
                            key="edit"
                            type="button"
                            className="btn btn-outline-primary border-0"
                            title="Editar Orden"
                            onClick={() => navigateTo('edit', { id: row.NUMBER })}
                        >
                            <FiEdit size={18} />
                        </button>
                    );
                }

                // ➤ Status 3,4,5 → Mostrar IMPRIMIR y RECIBIR
                if (status === 3 || status === 4 || status === 5) {
                    buttons.push(
                        <button
                            key="print"
                            type="button"
                            className="btn btn-outline-dark border-0"
                            title="Imprimir reporte de Orden"
                            onClick={() => handleOpenModal(row.NUMBER)}
                        >
                            <FiPrinter size={18} />
                        </button>
                    );

                    buttons.push(
                        <button
                            key="receive"
                            type="button"
                            className="btn btn-outline-success border-0"
                            title="Recibir Orden"
                            onClick={() => navigateTo('receive', { id: row.NUMBER })}
                        >
                            <FiCheckCircle size={22} />
                        </button>
                    );
                }

                // ➤ Status 6 → Ver reporte de recibido
                if (status === 6) {
                    buttons.push(
                        <button
                            key="view"
                            type="button"
                            className="btn btn-outline-success border-0"
                            title="Ver Historial de Orden"
                            //Funcion que mostrara el historial de la orden
                            // onClick={() => handleOpenModal('pdf', row.NUMBER)}
                            onClick={() => navigateTo('history', { id: row.NUMBER })}
                        >
                            <FiEye size={20} />
                        </button>
                    );
                }

                // ➤ Status 7 → No mostrar nada
                if (status === 7) {
                    buttons.push(
                        <button
                            key="view"
                            type="button"
                            className="btn btn-outline-danger border-0"
                            title="Ver Historial de Orden"
                            //Funcion que mostrara el historial de la orden
                            // onClick={() => handleOpenModal('pdf', row.NUMBER)}
                            onClick={() => navigateTo('history', { id: row.NUMBER })}
                        >
                            <FiEye size={20} />
                        </button>
                    );
                }

                return (
                    <div className="btn-group border-0" role="group">
                        {buttons}
                    </div>
                );
            }
        }

    ];



    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <>
            {showModal && (<M_Document detailRequest={detailRequestPDF} detailItems={detailItemsPDF} onClose={handleCloseModal} closeOnEscape={true} closeOnBackdrop={true} />)}
            <div className='row'>
                <div className='col-12'>
                    <h1 className="h3 mb-3 fw-bold">
                        Ordenes de Compra
                    </h1>
                </div>
                <div className='col-12 '>
                    <div className="card">
                        <div className="card-header border-bottom d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
                            <form className='row' onSubmit={handleSubmit(searchOrdenes)} >
                                <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                                    <label className="form-label">Fecha de Inicio:</label>
                                    <input type="date" defaultValue={firstDay} className="form-control" {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                                    {
                                        errors.fechaInicial &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="18" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                                        </div>
                                    }
                                </div>
                                <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4  ">
                                    <label className="form-label">Fecha de Termino:</label>
                                    <input type="date" className="form-control"  {...register("fechaFinal")} defaultValue={lastDay} />
                                </div>
                                <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 '>
                                    <label className="form-label">Estado:</label>
                                    <select className="form-select w-100" {...register("estado")}>
                                        <option value={0}>TODOS</option>
                                        <option value={1}>SOLICITADO</option>
                                        <option value={2}>REVISADO</option>
                                        <option value={3}>APROBADO</option>
                                        <option value={4}>POR RECIBIR</option>
                                        <option value={5}>PARCIAL</option>
                                        <option value={6}>COMPLETO</option>
                                        <option value={7}>CANCELADO</option>
                                    </select>
                                </div>

                                <div className="col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 col-xxl-1 mt-1">
                                    <div className=" mt-4">
                                        <button type="submit" className="btn btn-outline-secondary">
                                            <FiSearch size="20" />
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <div>
                                <button type="button" className="btn btn-outline-primary mt-4 w-100" onClick={() => navigateTo('new')}> Agregar nueva Orden de compra</button>
                            </div>
                        </div>


                        <div className="card-body">
                            <Table
                                columns={columns}
                                data={purchaseOrders}
                                function_={(row) => {
                                    setSelectedItem(row.number);
                                    // navigateTo('edit', { id: row.NUMBER });
                                }}
                                placeholderSearch="Buscar por: Folio, Capturante, Fecha, Estado"
                                showPagination={true}
                                showControls={true}
                                showTotals={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
